import { NgModule } from '@angular/core';
import { OverlayModule } from '@angular/cdk/overlay';
import { PortalModule } from '@angular/cdk/portal';
import {
  DIALOG_SCROLL_STRATEGY_PROVIDER,
  DialogService
} from './dialog.service';
import {
  DialogContainerTitle,
  DialogContainerActions,
  DialogContainerContent
} from './dialog-content-directives';
import { DialogContainer } from './dialog.component';
import { LayoutService } from '../services/layout.service';
import { ButtonModule } from '../button/button.module';
import { DialogAlertComponent } from './embedded/dialog-alert';
import { DialogConfirmComponent } from './embedded/dialog-confirm';
import { CommonModule } from '@angular/common';

@NgModule({
  declarations: [
    DialogContainer,
    DialogContainerTitle,
    DialogContainerActions,
    DialogContainerContent,
    DialogAlertComponent,
    DialogConfirmComponent
  ],
  imports: [CommonModule, OverlayModule, PortalModule, ButtonModule],
  exports: [
    DialogContainer,
    DialogContainerTitle,
    DialogContainerActions,
    DialogContainerContent
  ],
  entryComponents: [
    DialogContainer,
    DialogAlertComponent,
    DialogConfirmComponent
  ],
  providers: [DialogService, DIALOG_SCROLL_STRATEGY_PROVIDER, LayoutService]
})
export class DialogModule {}
